const Error: React.FC<{
    message: string
}> = ({ message }) => (
    <p  className={`text-red-500 text-[0.833rem] font-normal leading-6 italic`}>{message}</p>
)
export default Error